import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport'

export default el => {
    const $el = $(el);
    const $arrow = $el.find('[data-arrow]');
    const $arrowTarget = $el.find('[data-arrow-target]');
    const $visualsWrap = $el.find('[data-visuals]');
    const alwaysShow = $('body').hasClass('front');

    let triggerPosition;
    let arrowVisible = false;
    let isSetup = false;

    const updateArrow = () => {
        arrowVisible = !arrowVisible;
        $arrow.toggleClass('is-visible');
    };

    const onScroll = () => {
        const top = Viewport.scroll.top + Viewport.height;
        if (arrowVisible && top > triggerPosition) {
            updateArrow();
        } else if (!arrowVisible && top < triggerPosition) {
            updateArrow();
        }
    };

    const onResize = () => {
        triggerPosition = $visualsWrap.offset().top + $visualsWrap.height() + 10;
    };

    const onClick = e => {
        e.preventDefault();
        Viewport.scrollTo($arrowTarget.get(0), {
            offset: 5,
            duration: 600
        });
    };

    const setup = () => {
        isSetup = true;
        onResize();
        onScroll();
        Viewport.on('scroll', onScroll);
        Viewport.on('resize', onResize);
        $arrow.on('click', onClick);
    };

    const onBreakpoint = () => {
        if (!isSetup && Viewport.breakpoint.size >= 1200) {
            setup();
        } else if (isSetup && Viewport.breakpoint.size < 1200 && !alwaysShow) {
            destroy();
        }
    };

    const init = () => {
        Viewport.on('breakpoint', onBreakpoint);
        if (Viewport.breakpoint.size >= 1200 || alwaysShow) {
            setup();
        }
    };

    const destroy = () => {
        isSetup = false;
        Viewport.off('scroll', onScroll);
        Viewport.off('resize', onResize);
        $arrow.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Hero.js